import { Link } from 'react-router-dom';
import { useT } from '../i18n/useT';

export default function NotFoundPage() {
  const t = useT();
  return (
    <section className="flex flex-col items-center gap-3 py-16 text-center">
      <p className="num text-4xl font-semibold text-muted">404</p>
      <h1 className="text-lg font-semibold">{t('shell.not_found.title')}</h1>
      <Link to="/" className="text-sm text-accent hover:underline">
        {t('common.back_to_markets')}
      </Link>
    </section>
  );
}
